// extracted by mini-css-extract-plugin
module.exports = {"faqs":"QuestionSection_faqs__B35b0","faqItem":"QuestionSection_faqItem__2LCpo","faqIcon":"QuestionSection_faqIcon__z345Y","faqContent":"QuestionSection_faqContent__eVTG5"};